module.exports = __webpack_public_path__ + "img/Agents Only_en.767148c.png";